export default {"src":"/_next/static/media/good-stuff-glasses.802b32d9.svg","height":218,"width":202};